// Логика скролла хедера
export function initHeaderScroll() {
  function updateHeaderScrolled() {
    const header = document.querySelector('.header');
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 200);
  }
  let scrollTicking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => {
        updateHeaderScrolled();
        scrollTicking = false;
      });
    },
    { passive: true }
  );
  window.addEventListener('load', updateHeaderScrolled);
}
